module.exports = __webpack_public_path__ + "img/crea-compte@2x.97147782.png";